import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import TextPrivacyPolicy from '../../../../../../utils/privacy-policy';

const PrivacyPolicy = ({open, onClose}) => {
  return(
    <Dialog
        open={open}
        onClose={onClose}
        scroll="paper"
        PaperProps={{style: {
          maxWidth: 800
        }}}
        onBackdropClick={onClose}
      >
        <DialogTitle style={{textAlign: 'center', fontSize: 18}}>Panafold Privacy Policy</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
          >
          <TextPrivacyPolicy />
          </DialogContentText>
        </DialogContent>
      </Dialog>
  )
};

export default PrivacyPolicy;